import { store } from "../../store/index";
import { isDefined } from "../../../ceres/helper/utils";
import Vue from "vue";

Vue.directive("populate-store", {
	bind(el, binding) {
		const name = binding.value.name;
		const data = binding.value.data;
		const type = binding.arg;

		if (App.Eros.Config.general.benchmarkJS) console.time("App.eros.directives.helper.populateStore: bind_" + name); // eslint-disable-line no-console

		if (isDefined(name)) {
			if (type === "action") {
				store.dispatch(name, data);
			} else if (type === "mutation") {
				store.commit(name, data);
			}
		}

		if (App.Eros.Config.general.benchmarkJS) console.timeEnd("App.eros.directives.helper.populateStore: bind_" + name); // eslint-disable-line no-console
	}
});
